var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#E7F7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7513 14.1562C12.743 14.1562 11.918 14.9813 11.918 15.9896V26.9896C11.918 27.9979 12.743 28.8229 13.7513 28.8229H23.3763C23.127 28.2401 22.9722 27.6212 22.918 26.9896H13.7513V17.8229L21.0846 22.4063L28.418 17.8229V20.5729C28.5707 20.5675 28.7236 20.5675 28.8763 20.5729C29.3395 20.5743 29.8009 20.6297 30.2513 20.7379V15.9896C30.2513 14.9813 29.4263 14.1562 28.418 14.1562H13.7513ZM13.7513 15.9896H28.418L21.0846 20.5729L13.7513 15.9896Z",
    fill: "#06AED4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1645 22.963C30.2619 22.9597 30.3569 22.9943 30.4287 23.0602C30.5005 23.1261 30.543 23.2178 30.5481 23.3151C30.5531 23.4124 30.5186 23.5081 30.4539 23.5811L26.9894 27.3579C26.9499 27.401 26.9022 27.436 26.8492 27.4607C26.7961 27.4854 26.7385 27.4996 26.6799 27.5022C26.6214 27.5046 26.5627 27.4954 26.5077 27.4753C26.4802 27.4653 26.4537 27.4528 26.4289 27.4377L26.3592 27.3849L24.4961 25.6751C24.4236 25.6084 24.3809 25.5156 24.3766 25.4172C24.3723 25.3188 24.4072 25.2228 24.4736 25.1502C24.5402 25.0776 24.633 25.034 24.7314 25.0296C24.8299 25.0254 24.9268 25.06 24.9995 25.1266L26.369 26.3836L26.6428 26.6358L26.8939 26.3611L29.9075 23.0786C29.9746 23.0079 30.0671 22.9663 30.1645 22.963Z",
    fill: "#06AED4",
    stroke: "#06AED4",
    strokeWidth: 0.74358
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSentIcon);
export default __webpack_public_path__ + "static/media/EmailSent-icon.e55c71bf1ed5925499e49e9df179dd4b.svg";
export { ForwardRef as ReactComponent };